// extracted by mini-css-extract-plugin
export default {"TextArea":"ai1NN5DaN6S32hCPneOn"};